var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4.646 5.134 60 48",
    width: "60px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2371_2102",
    x1: -1.0886,
    y1: 25.0304,
    x2: 60.978,
    y2: 25.0304,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 4.645668, 5.110439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 26.846 41.134 L 34.646 33.334 L 42.446 41.134 L 46.646 36.934 L 38.846 29.134 L 46.646 21.334 L 42.446 17.134 L 34.646 24.934 L 26.846 17.134 L 22.646 21.334 L 30.446 29.134 L 22.646 36.934 L 26.846 41.134 Z M 10.646 53.134 C 8.996 53.134 7.583 52.547 6.408 51.372 C 5.233 50.197 4.646 48.784 4.646 47.134 L 4.646 11.134 C 4.646 9.484 5.233 8.072 6.408 6.897 C 7.583 5.722 8.996 5.134 10.646 5.134 L 58.646 5.134 C 60.296 5.134 61.708 5.722 62.883 6.897 C 64.058 8.072 64.646 9.484 64.646 11.134 L 64.646 47.134 C 64.646 48.784 64.058 50.197 62.883 51.372 C 61.708 52.547 60.296 53.134 58.646 53.134 L 10.646 53.134 Z M 10.646 47.134 L 58.646 47.134 L 58.646 11.134 L 10.646 11.134 L 10.646 47.134 Z",
    fill: "url(#paint0_linear_2371_2102)",
    id: "object-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.387647c49de5e4332df5cbaae6417b7d.svg";
export { ForwardRef as ReactComponent };